import { call } from "../core";

export const callGetArticles = () => {
  return call('/article/list/all', "GET", {});
};

export const callGetArticle = (id: string) => {
  return call(`/article/${id}`, "GET", {});
};
